// GENERATED by blackbird_backend/scripts/tools/generate-discipline-registry.mjs. Do not edit.
// Source: blackbird_backend/src/layers/shared-utils/nodejs/clinical/therapyCodes.js (Phase 20C)

export type TherapyCodeKind = 'EVAL' | 'REEVAL' | 'TIMED' | 'SESSION';

export interface TherapyCodeEntry {
  code: string;
  discipline: string;
  kind: TherapyCodeKind;
  label: string;
  exclusiveGroup?: string;
}

export const THERAPY_CODES: readonly TherapyCodeEntry[] = [
  {
    "code": "97161",
    "discipline": "PT",
    "kind": "EVAL",
    "label": "PT evaluation, low complexity"
  },
  {
    "code": "97162",
    "discipline": "PT",
    "kind": "EVAL",
    "label": "PT evaluation, moderate complexity"
  },
  {
    "code": "97163",
    "discipline": "PT",
    "kind": "EVAL",
    "label": "PT evaluation, high complexity"
  },
  {
    "code": "97164",
    "discipline": "PT",
    "kind": "REEVAL",
    "label": "PT re-evaluation"
  },
  {
    "code": "97165",
    "discipline": "OT",
    "kind": "EVAL",
    "label": "OT evaluation, low complexity"
  },
  {
    "code": "97166",
    "discipline": "OT",
    "kind": "EVAL",
    "label": "OT evaluation, moderate complexity"
  },
  {
    "code": "97167",
    "discipline": "OT",
    "kind": "EVAL",
    "label": "OT evaluation, high complexity"
  },
  {
    "code": "97168",
    "discipline": "OT",
    "kind": "REEVAL",
    "label": "OT re-evaluation"
  },
  {
    "code": "97110",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Therapeutic exercise"
  },
  {
    "code": "97110",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Therapeutic exercise"
  },
  {
    "code": "97112",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Neuromuscular re-education"
  },
  {
    "code": "97112",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Neuromuscular re-education"
  },
  {
    "code": "97116",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Gait training"
  },
  {
    "code": "97116",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Gait training"
  },
  {
    "code": "97140",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Manual therapy"
  },
  {
    "code": "97140",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Manual therapy"
  },
  {
    "code": "97530",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Therapeutic activities"
  },
  {
    "code": "97530",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Therapeutic activities"
  },
  {
    "code": "97535",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Self-care / home management training"
  },
  {
    "code": "97535",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Self-care / home management training"
  },
  {
    "code": "97542",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Wheelchair management training"
  },
  {
    "code": "97542",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Wheelchair management training"
  },
  {
    "code": "97760",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Orthotic management and training"
  },
  {
    "code": "97760",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Orthotic management and training"
  },
  {
    "code": "97761",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Prosthetic training"
  },
  {
    "code": "97761",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Prosthetic training"
  },
  {
    "code": "97763",
    "discipline": "PT",
    "kind": "TIMED",
    "label": "Orthotic / prosthetic follow-up"
  },
  {
    "code": "97763",
    "discipline": "OT",
    "kind": "TIMED",
    "label": "Orthotic / prosthetic follow-up"
  },
  {
    "code": "92521",
    "discipline": "ST",
    "kind": "EVAL",
    "label": "Evaluation of speech fluency"
  },
  {
    "code": "92522",
    "discipline": "ST",
    "kind": "EVAL",
    "label": "Evaluation of speech sound production"
  },
  {
    "code": "92523",
    "discipline": "ST",
    "kind": "EVAL",
    "label": "Evaluation of speech sound production with language"
  },
  {
    "code": "92524",
    "discipline": "ST",
    "kind": "EVAL",
    "label": "Behavioral and qualitative analysis of voice and resonance"
  },
  {
    "code": "92610",
    "discipline": "ST",
    "kind": "EVAL",
    "label": "Evaluation of oral and pharyngeal swallowing function"
  },
  {
    "code": "S9152",
    "discipline": "ST",
    "kind": "REEVAL",
    "label": "Speech therapy re-evaluation"
  },
  {
    "code": "92507",
    "discipline": "ST",
    "kind": "SESSION",
    "label": "Speech, language, voice or communication treatment (individual)",
    "exclusiveGroup": "ST_TREATMENT"
  },
  {
    "code": "92526",
    "discipline": "ST",
    "kind": "SESSION",
    "label": "Treatment of swallowing dysfunction / oral function for feeding",
    "exclusiveGroup": "ST_TREATMENT"
  },
  {
    "code": "92508",
    "discipline": "ST",
    "kind": "SESSION",
    "label": "Speech treatment, group"
  }
];

export const THERAPY_DISCIPLINE_MODIFIER: Readonly<Record<string, string>> = {
  "PT": "GP",
  "OT": "GO",
  "ST": "GN"
};
export const TIMED_UNITS_PER_DAY = 4;
export const MINUTES_PER_UNIT = 15;
export const GOAL_PROGRESS = [
  "PROGRESSING",
  "MET",
  "NO_CHANGE",
  "REGRESSED"
] as const;
export type GoalProgress = typeof GOAL_PROGRESS[number];
